module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/archive-e07fb5d87be7b1c451965e1d0d51efcf.svg";